module.exports = __webpack_public_path__ + "img/Slideshows-espace-client-permanents3.1b35336d.png";